import React from "react";
import { Container, Box, Typography } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import useCheckoutClassicStyles from "./checkoutClassicStyles";
import SupportCard from "./SupportCard";

export default function SuccessScreen({ firstName, affiliate }) {
  const classes = useCheckoutClassicStyles();

  const referralLink = affiliate && affiliate.referralLink;

  return (
    <div className={classes.root}>
      <Container className={classes.container} maxWidth="sm">
        <Box className={classes.successCard} style={{ textAlign: "center" }}>
          <CheckCircleIcon className={classes.successIcon} />
          <Typography variant="h5" className={classes.successTitle}>
            Payment successful
          </Typography>
          <Typography className={classes.successSub}>
            {`Thanks${firstName ? `, ${firstName}` : ""} — your order is confirmed.`}
          </Typography>

          <Box className={classes.successNextStep}>
            🔑 Your access code is on its way to your WhatsApp &amp; email — usually within 2 minutes.
          </Box>

          {referralLink && (
            <a className={classes.successPrimaryBtn} href={referralLink} target="_blank" rel="noreferrer noopener">
              Open AiSensy →
            </a>
          )}

          <SupportCard affiliate={affiliate} />
        </Box>
      </Container>
    </div>
  );
}
